import { XtremePushGlobal, XtremePushGlobalBadge } from './types';

export const handleItvMessagesBadge = (callback: (arg: number) => void): void => {
  (window as unknown as XtremePushGlobalBadge).xtremepush('ready', function () {
    // make sure to retrieve inbox badge inside ready callback to ensure that user is registered
    (window as unknown as XtremePushGlobal).xtremepush(
      'inbox',
      'badge',
      {},
      (result) => callback(Number(result.badge)),
      (error) => console.log(error)
    );
  });
};

export const getMessageCreateTime = (timeStamp: number, separator: string): string => {
  const createdDate = new Date(timeStamp * 1000);
  const createdDateString = createdDate.toLocaleDateString('en-GB');
  const todayDateString = new Date().toLocaleDateString('en-GB');

  const timeString = createdDate.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  const prefixString = createdDateString === todayDateString ? 'Today' : createdDateString.replaceAll('/', '.');

  return `${prefixString} ${separator} ${timeString}`;
};
